import React, { useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Box,
  IconButton,
  Tooltip as MuiTooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const HuellaPie = () => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = [
    'Alimentos',
    'Construcción',
    'Retail',
    'Servicios logísticos',
    'No mide su huella de carbono',
  ];

  const data2024 = [2, 2, 6, 6, 84];

  const colorMap = {
    'Alimentos': '#172B3E',
    'Retail': '#1F3D58',
    'Servicios logísticos': '#476A8E',
    'No mide su huella de carbono': '#4B73B1',
    'Construcción': '#B0B0B0',
  };

  const chartData = {
    labels: allLabels,
    datasets: [
      {
        label: '2023',
        data: data2024,
        backgroundColor: allLabels.map((label) => `${colorMap[label] || '#ccc'}B3`),
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        onClick: () => {}, // no hace nada al hacer click en la leyenda
      },
      tooltip: {
        callbacks: {
          label: (context) =>
            `${context.dataset.label} - ${context.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#fff',
        font: { weight: 'bold', size: 14 },
        formatter: (value) => `${value}%`,
        anchor: 'center',
        align: 'center',
      },
    },
  };

  const infoContent = {
    Analisis:
      'La gráfica muestra el nivel de adopción de prácticas de medición de la huella de carbono en procesos logísticos por parte de las industrias en 2023. Aunque algunos sectores como Retail y Servicios logísticos han comenzado a incorporar esta métrica (con un 6% de participación), el 84% de las empresas aún no mide su impacto ambiental en logística.',
    formula:
      'Número de industria que lo mide / Total de industrias del estudio',
    description:
      'Esto refleja una oportunidad significativa para avanzar en sostenibilidad, así como la necesidad de fortalecer capacidades y herramientas que permitan a más organizaciones integrar este indicador en sus operaciones.',
  };

  return (
    <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>

      <div style={{ width: '100%', maxWidth: '400px', height: '400px', margin: '0 auto' }}>
        <Doughnut data={chartData} options={options} />
      </div>

      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HuellaPie;
